module.exports = __webpack_public_path__ + "resources/img/sample_thumbnail.fdd0aa07940515aa9e5276dc33de347c.png";